import React from "react";
import MList from "@mui/material/List";

const List = (props) => {
  return <MList {...props} />
};

export default List;
